import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GoogleAnalyticsEventsService } from 'src/app/services/google-analytics-events.service';
import { PrinterService } from 'src/app/services/printer.service';
import { AcceptModalComponent } from '../../dialogs/accept-modal/accept-modal.component';
import { SuccessModalComponent } from '../../dialogs/add-customer-printer-dialog/success-modal/success-modal.component';
import { SnackbarComponent } from '../snackbar/snackbar.component';

@Component({
  selector: 'app-proactive-feedback',
  templateUrl: './proactive-feedback.component.html',
  styleUrls: ['./proactive-feedback.component.scss']
})
export class ProactiveFeedbackComponent implements OnInit {

  popUpStatus: boolean;
  isResponse: boolean = false;
  isSuccess: boolean = false;
  positiveFeed: boolean = false;
  negativeFeed: boolean = false;
  submitData: boolean = true;
  options = []
  feedback: string = '';
  alertInfo: any;
  userClosed: boolean = false;
  closedCase: boolean = false;
  proactive: boolean = false;
  case_id: any;
  status: boolean = false;
  isLoading: boolean = false
  constructor(
    public dialogRef: MatDialogRef<ProactiveFeedbackComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private printerService: PrinterService,
    private snackbar: MatSnackBar,
    private googleAnalyticsEventsService: GoogleAnalyticsEventsService
  ) { }

  ngOnInit(): void {
    console.log(this.data)
    this.submitData = true
    this.isResponse = true;
    this.popUpStatus = this.data?.popUpStatus;
    this.alertInfo = this.data?.alertInfo;
    this.closedCase = this.data?.isClosed;
    this.case_id = this.data?.caseId || this.data?.caseID;
    this.setPopUp(this.popUpStatus, this.data?.feedbackOptions)

  }

  setPopUp(status, feedbacks) {
    if (status) {
      this.submitData = false
      this.isResponse = false;
      this.positiveFeed = true;
      this.negativeFeed = false;
    } else {
      this.isResponse = false;
      this.negativeFeed = true;
      feedbacks.map(feed => {
        this.options.push(feed.value)
      })
      this.positiveFeed = false;
    }
    if (this.closedCase) {
      this.submitData = false
      this.isResponse = true;
      this.positiveFeed = false;
      this.negativeFeed = false;
    }
  }
  close() {
    this.userClosed = true;
    if (this.alertInfo != undefined && this.alertInfo?.actionUuid) {
      this.saveData()
      this.dialogRef.close({ status: 'reload', success: true })
    } else{
      this.dialogRef.close({ status: 'reload', success: false })
    }

  }

  feedbackSelected(selected) {
    this.popUpStatus = selected
    if (!selected) {
      this.isResponse = false;
      this.negativeFeed = true;
      this.submitData = true

    } else {
      this.negativeFeed = false;
      this.isResponse = false;
      this.positiveFeed = true;
      this.submitData = false
    }
  }

  submitFeedback() {
    console.log(this.submitData)
    if (!this.submitData) {
      this.negativeFeed = false;
      this.isSuccess = true;
      this.userClosed = false
      this.saveData()
    }

  }

  saveData() {
    this.isLoading = true
    let body: any;
    body = {
      case_id: this.case_id,
      action_id: this.alertInfo?.actionUuid, // id of the alert
      was_alert_helpful: this.popUpStatus, // true if alert helpful option is selected as Yes, false if No
      comments: this.feedback, // Share your thoughts
      feedback: this.selected,
      alert_dismissed_by_user: this.userClosed // true if User dismissed the feedback popup or closes the feedback without submitting
    }

    // if (body.actionUuid && body.product_number && body.serial_number) {
      this.printerService.saveFeedback(body).subscribe(response => {
        console.log(response)
        let element = this.data.alertInfo
        this.status = response.result_status
        let selectedStatus = this.popUpStatus ? 'Yes' : 'No'
        let caseID =  this.case_id ? `| ${this.case_id}` : ''
        this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'feedback_yes_no_tap', `web | ${element?.error_code} ${caseID} | ${element?.product_number} | ${element?.serial_number} | ${selectedStatus}`, null)

        this.isLoading = false;
        this.dialogRef.close({ success: true });
        let ref = this.dialog.open(AcceptModalComponent, {
          panelClass: 'accept-dailog',
          backdropClass: 'dialog-backdrop',
          disableClose: false,
          position: { right: '20px', bottom: '25px' },
          maxWidth: '500px',
          maxHeight: '220px',
          data: {
            title: "PRO_ACTIVE_FEEDBACK.HEADER",
            body: "PRO_ACTIVE_FEEDBACK.MESSAGE",
            isOkay: false,
            isClose: true,
            showButtons: false
          }
        });

        ref.afterOpened().subscribe(_ => {
          setTimeout(() => {
            ref.close({ status: 'reload' });
          }, 60000)
        })

      }, err => {
        this.isLoading = false
        this.printerService.failedModal(err?.error?.result?.message, "");
        this.dialogRef.close();
      })
    // }

    // sent flag as response/ to disable the options in proactive
  }
  selected: string = '';

  onItemChange(value: any) {
    this.selected = value;
    if (this.selected) {
      this.submitData = false
    }
  }
}
